import React from 'react';
import DocumentsV2Compact from '../../../../components/DocUploadV2/DocumentsV2Compact';

export const composeHint = (remarkNode, hintNode) => {
    if (remarkNode && hintNode) {
        return (
            <>
                {remarkNode}
                {' '}
                {hintNode}
            </>
        );
    }
    return remarkNode || hintNode || undefined;
};

const ProofOfDocumentCompactV2 = ({
    supportedFiles = ["image", "pdf"],
    single = false,
    enableOnline,
    seq,
    isAskForInfo,
    remark,
    recordId,
    asLabel,
    label,
    hint,
    field,
    showCategory,
    ubo_id,
    type,
    formId,
    required = true,
    error = "",
    validateByAi = false,
    onValidationStatusChange = () => { },
    onDocumentsChanged,
    dataTestId,
}) => {
    return (
        <div className='docv2__wrap' data-testid={dataTestId}>
            <DocumentsV2Compact
                label={label}
                required={required}
                hint={composeHint(isAskForInfo && remark ? remark : null, hint)}
                asLabel={asLabel}
                inline
                seq={seq}
                field={field}
                record_id={recordId}
                showCategory={showCategory}
                ubo_id={ubo_id}
                type={type}
                formId={formId}
                hideUpload
                enableOnline={enableOnline}
                supportedFiles={supportedFiles}
                single={single}
                error={error}
                validateByAi={validateByAi}
                onValidationStatusChange={onValidationStatusChange}
                onDocumentsChanged={onDocumentsChanged}
            />
        </div>
    );
};

export default ProofOfDocumentCompactV2;
